import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import { useAppStore } from "@hooks/useAppStore";
import type { BaseItemSchema } from "@memorang/types";
import HintAccordion from "@memorang/ui/components/HintAccordion";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { AIFeedbackMenu } from "../components/AIFeedbackMenu";
import { useHint } from "../hooks/useHint";

const HintContainerInner = ({ item }: { item: BaseItemSchema }) => {
	const { hints, loading, streaming, getHint } = useHint({ item });
	const [showHint, setShowHint] = useState(false);
	const { t } = useTranslation();

	const lastHint = useMemo(() => hints[hints.length - 1]?.text, [hints]);

	useAnalytics(
		{
			eventName: events.sessionItemHintGiven,
			itemId: `${item.id}`,
			hint: lastHint ?? "",
		},
		showHint && !loading && !streaming,
	);

	const handleToggle = () => {
		setShowHint((prev) => !prev);
		getHint();
	};

	return (
		<HintAccordion
			hint={lastHint}
			loading={loading}
			streaming={streaming}
			title={t("session.hint.show")}
			expanded={showHint}
			onToggle={handleToggle}
			actionContent={
				<AIFeedbackMenu
					itemId={item.id!}
					featureName="AI Hint"
					disabled={streaming}
				/>
			}
		/>
	);
};

const HintContainer = ({ item }: { item: BaseItemSchema }) => {
	const hintEnabled = Boolean(
		useAppStore((store) => store.sessionView?.ai?.hint),
	);
	if (!hintEnabled) {
		return null;
	}
	return <HintContainerInner item={item} />;
};

export default HintContainer;
